/* eslint-disable no-unused-vars,@typescript-eslint/no-unused-vars */
import BasePresenter from '@src/js/separate-logic/base-presenter';
import { dispatchProps } from '@src/js/separate-logic/decorate/dispatchProps';
import { external } from '@src/js/separate-logic/decorate/external';
import { IHistoryManager } from '@src/slide/application/service/history-manager/core/history-manager.interface';
import { hexToRgba } from '@src/slide/infrastructure/module/independent/color/transform';

export default class CellWrapperPresenter extends BasePresenter {
    // eslint-disable-next-line complexity
    public shouldComponentUpdate(nextProps): boolean {
        // 非选中、拖拽或分隔线变化时，阻止刷新
        return this.props.isSelected !== nextProps.isSelected
                || this.props.draging !== nextProps.draging
                || nextProps.clearanceIndex === nextProps.slideClearanceIndex
                || (this.props.clearanceIndex === this.props.slideClearanceIndex
                    && nextProps.clearanceIndex !== nextProps.slideClearanceIndex)
                // slide-list 有改动（比如添加了新的节，或者新增页面等等导致原 clearanceIndex 有改变，需要重新渲染）
                || this.props.clearanceIndex !== nextProps.clearanceIndex
                || nextProps.currentDragIndex !== this.props.currentDragIndex
                || nextProps.cellIndex !== this.props.cellIndex
                || nextProps.lockInfo !== this.props.lockInfo
                || nextProps.sizeType !== this.props.sizeType
                || nextProps.slideWidth !== this.props.slideWidth
                || nextProps.slideHeight !== this.props.slideHeight
                || nextProps.slideInnerHeight !== this.props.slideInnerHeight
                || nextProps.renderCellIndex !== this.props.renderCellIndex;
    }

    @external()
    public cloneDom = cloneDeep => this.getChildRef('cellRef')?.cloneDom(cloneDeep);

    @dispatchProps()
    public getHistoryColor(): string {
        const {
            cellIndex,
            getHistoryManager,
        } = this.props as { cellIndex: number, getHistoryManager: () => IHistoryManager | undefined };
        let bgColor = '';
        const historyManager = getHistoryManager?.();
        // 修订记录：根据修改作者调整背景色
        if (historyManager?.isShowingHistory) {
            const { modification } = historyManager;
            const authors = modification?.[cellIndex];
            if (authors) {
                const id = authors[authors.length - 1];
                if (id) {
                    const hexColor = historyManager.getColorForId(id);
                    bgColor = hexToRgba(hexColor, 0.2);
                }
            }
        }
        return bgColor;
    }
}
